<template>
  <div>
    <div class="header-pane" :style="{ height: headerHeight + 'px' }">
      <div class="logo" :style="{ height: logoHeight + 'px', lineHeight: logoHeight + 'px' }">
        <img
            :src="'/imgs/logo.png'"
            :style="{
              width: logoWidth + 'px',
              height: logoHeight + 'px'
            }"
            alt="Logo"/>
      </div>

      <div class="header-content">
        <ul class="menu-box">
          <li
              class="menu-item"
              v-for="(item,index) in $t('topMenu')"
              :key="item"
              @click="handleMenuClick(item.anchor)"
              :class="{ 'active': activeMenu === item.anchor }">
            <span class="menu-item-title">{{ item.name }}</span>
          </li>
        </ul>
      </div>

      <div class="dropdown">
        <button class="dropdown-button" @click="toggleDropdown">
          {{ getNameByValue(language) }}
          <span class="caret"><icon class="el-icon-arrow-down"></icon></span>
        </button>
        <div class="dropdown-content" v-if="showDropdown">
          <div
              v-for="(lang, index) in languages"
              :key="index"
              @click="changeLangEvent(lang.value)"
              class="dropdown-item"
          >
            {{ lang.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="header-placeholder" :style="{ height: headerHeight + 'px' }"></div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      activeMenu: '',
      footerMenu: [
        {
          name: 'About',
          anchor: 'About'
        },
        {
          name: 'Vision',
          anchor: 'Vision'
        },
        {
          name: 'Approach',
          anchor: 'Approach'
        },
        {
          name: 'Focus Areas',
          anchor: 'FocusAreas'
        },
        {
          name: 'Values',
          anchor: 'Values'
        },
        {
          name: 'Services',
          anchor: 'Services'
        },
        {
          name: 'Contact',
          anchor: 'Contact'
        }
      ],
      showDropdown: false,
      language: localStorage.getItem("locale") || "en",
      languages: [
        {
          name: 'English',
          value: 'en'
        },
        {
          name: '简体中文',
          value: 'cn'
        }
      ]
    };
  },
  computed: {
    headerHeight() {
      const baseRatio = 0.1;
      const minHeight = 60;
      const maxHeight = 120;
      const calculatedHeight = this.windowWidth * baseRatio;
      return Math.min(Math.max(calculatedHeight, minHeight), maxHeight);
    },
    logoWidth() {
      const baseRatio = 0.15;
      const minWidth = 120;
      const maxWidth = 210;
      const calculatedWidth = this.windowWidth * baseRatio;
      return Math.min(Math.max(calculatedWidth, minWidth), maxWidth);
    },
    logoHeight() {
      return this.headerHeight * 0.7;
    }
  },
  methods: {
    getNameByValue(value) {
      const lang = this.languages.find(lang => lang.value === value);
      return lang ? lang.name : '';
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    changeLangEvent(value){
      localStorage.setItem("locale", value);
      this.$i18n.locale = localStorage.getItem("locale");
      this.language = value;
      location.reload();
      this.showDropdown = false;
    },
    handleResize() {
      this.$nextTick(() => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
      });
    },
    handleMenuClick(anchorId) {
      if (anchorId) {
        // 更新激活状态
        this.activeMenu = anchorId;

        const targetElement = document.getElementById(anchorId);
        if (targetElement) {
          const headerOffset = this.headerHeight;
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    },
    handleScroll() {
      const headerOffset = this.headerHeight;
      // 默认保持当前激活状态
      let currentActiveMenu = this.activeMenu;

      // 获取页面滚动信息
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 检查是否接近页面底部（距离底部100px以内）
      const isNearBottom = scrollTop + windowHeight >= documentHeight - 100;

      if (isNearBottom) {
        // 接近底部时，激活最后一个菜单项
        currentActiveMenu = this.footerMenu[this.footerMenu.length - 1].anchor;
      } else {
        // 从下往上查找第一个在视口中的元素
        for (let i = this.footerMenu.length - 1; i >= 0; i--) {
          const item = this.footerMenu[i];
          const element = document.getElementById(item.anchor);
          if (element) {
            const rect = element.getBoundingClientRect();
            // 检查元素是否在视口中（考虑头部偏移）
            if (rect.top <= headerOffset + 100 && rect.bottom >= headerOffset) {
              currentActiveMenu = item.anchor;
              break;
            }
          }
        }
      }

      // 只有当激活项发生变化时才更新
      if (currentActiveMenu !== this.activeMenu) {
        this.activeMenu = currentActiveMenu;
      }
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll); // 添加滚动监听
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动监听
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-select-dropdown {
  margin: 0;
  padding: 0;
  background: none;
}

.backstage {
  position: absolute;
  right: 30px;
  top: 35px;
  cursor: pointer;
}

.head-box {
  width: 100%;
  transition: all 0.5s ease-in-out;
}

.header-position {
  position: absolute;
  z-index: 9;
  color: #fff;
}

.header-pane {
  display: flex;
  align-items: center;
  position: fixed; /* 改为 fixed 以固定在顶部 */
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff; /* 添加背景色 */
  box-shadow: 0 2px 4px rgba(0,0,0,.1); /* 添加阴影 */
  transition: height 0.3s ease;
  padding: 0 clamp(20px, 2vw, 40px); /* 调整 padding */

  .text {
    width: 310px;
  }

  .logo {
    cursor: pointer;
    /* 改为相对定位，使其位置更灵活 */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: height 0.3s ease, line-height 0.3s ease;
    margin-right: clamp(10px, 2vw, 30px); /* 添加右边距与菜单项分隔 */
    flex-shrink: 0; /* 防止logo被压缩 */

    img {
      object-fit: contain;
      transition: all 0.3s ease;
      max-width: 100%;
    }
  }

  .header-content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dropdown {
    margin-left: clamp(5px, 1vw, 15px); /* 控制与菜单的间距 */
    width: fit-content;
    z-index: 10;
    position: relative; /* 添加相对定位 */

    .dropdown-button {
      height: v-bind('logoHeight * 0.6 + "px"');
      line-height: v-bind('logoHeight * 0.6 + "px"');
      font-size: clamp(12px, 1.5vw, 20px); /* 减小字体大小 */
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;

      .caret {
        margin-left: 5px;
      }
    }

    .dropdown-content {
      position: absolute;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      z-index: 1000;
      min-width: 100px;
      left: 0; /* 改为 left: 0 使其对齐到左侧 */
      top: 100%; /* 保持在下方 */
      margin-top: 5px; /* 与按钮保持间距 */

      .dropdown-item {
        padding: 6px 12px; /* 减小内边距 */
        cursor: pointer;
        font-size: clamp(10px, 1.2vw, 16px); /* 进一步减小字体大小 */

        &:hover {
          background-color: #f5f5f5;
        }
      }
    }
  }
}

/* 添加占位元素样式 */
.header-placeholder {
  width: 100%;
}

.menu-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  padding: 0;

  .menu-item {
    /* 现有样式保持不变 */
    height: v-bind('logoHeight + "px"');
    line-height: v-bind('logoHeight + "px"');
    margin: 0 clamp(5px, 1.5vw, 25px);
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    .menu-item-title {
      /* 现有样式保持不变 */
      width: auto;
      min-width: 50px;
      height: v-bind('logoHeight * 0.6 + "px"');
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: clamp(14px, 1.8vw, 24px);
      color: #101010;
      line-height: v-bind('logoHeight * 0.6 + "px"');
      text-align: left;
      font-style: normal;
      white-space: nowrap;
    }

    /* 激活状态样式 - 调整横线位置 */
    &.active {
      .menu-item-title {
        color: #000;
        font-weight: bold;
      }

      /* 调整底部横线位置，更贴近菜单栏边缘 */
      &:after {
        content: '';
        position: absolute;
        bottom: calc(-1 * (var(--header-pane-padding, 40px) + 4px)); /* 调整到底部padding位置 */
        left: 0;
        width: 100%;
        height: 4px;
        background-color: #000;
        border-radius: 2px;
      }
    }

    &:hover {
      .menu-item-title {
        color: #000;
        font-weight: bold;
      }

      /* 调整鼠标悬停时横线位置 */
      &:after {
        content: '';
        position: absolute;
        bottom: calc(-1 * (var(--header-pane-padding, 40px) + 4px)); /* 调整到底部padding位置 */
        left: 0;
        width: 100%;
        height: 4px;
        background-color: #000;
        border-radius: 2px;
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-pane {
    flex-direction: row; /* 保持横向排列 */
    height: auto !important;
    padding: 10px clamp(10px, 2vw, 20px);

    .logo {
      position: relative;
      transform: none;
      margin-bottom: 0;
      margin-right: 15px;
    }

    .header-content {
      flex-wrap: wrap;

      .menu-box {
        order: 2;
        width: 100%;
        justify-content: center;
      }
    }

    .dropdown {
      order: 1;
      margin-left: 0;
      margin-bottom: 10px;
    }
  }

  .menu-box {
    flex-wrap: wrap;
    max-width: 100%;

    .menu-item {
      margin: 5px;

      &.active,
      &:hover {
        &:after {
          bottom: calc(-1 * (var(--header-pane-padding-mobile, 20px) + 4px));
        }
      }
    }
  }
}
</style>
